import { render } from "./Follow.vue?vue&type=template&id=3936891a&scoped=true"
import script from "./Follow.vue?vue&type=script&lang=ts"
export * from "./Follow.vue?vue&type=script&lang=ts"

import "./Follow.vue?vue&type=style&index=0&id=3936891a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3936891a"

export default script